module.exports = __webpack_public_path__ + "static/fonts/text-security-circle-compat.6547c06.ttf";